export default __webpack_public_path__ + "static/media/ic_timeline_step_pin.4122a28f.svg";